import React, { useContext } from "react";
import { AppContext } from "../containers/All";

const HeaderText = ({ merchant }) => {
  const { settings } = useContext(AppContext);
  const { headerAdjective, headerNoun } = settings;

  const header = `Here's what our ${headerAdjective || "happy"} ${headerNoun || "customers"} are saying...`;

  if (merchant.numReviews > 0) {
    return <h3 className="header-text">{header}</h3>;
  } else {
    return null;
  }
};

export default HeaderText;



// WEBPACK FOOTER //
// ./src/components/headerText.js